export function fmtArr(n: number | null | undefined, digits = 2): string {
  if (n == null) return "—";
  const v = Number(n);
  if (Number.isNaN(v)) return "—";
  const a = Math.abs(v);
  if (a >= 1_000_000) return `$${(v / 1_000_000).toFixed(digits)}M`;
  if (a >= 1_000) return `$${(v / 1_000).toFixed(0)}K`;
  return `$${Math.round(v).toLocaleString("en-US")}`;
}

/** Whole-dollar, comma-separated, no decimals or M/K abbreviation. */
export function fmtUsd0(n: number | null | undefined): string {
  if (n == null) return "—";
  const v = Number(n);
  if (Number.isNaN(v)) return "—";
  return `$${Math.round(v).toLocaleString("en-US")}`;
}

export function fmtSignedPct(n: number | null | undefined, digits = 1): string {
  if (n == null) return "—";
  const v = Number(n);
  if (Number.isNaN(v)) return "—";
  return `${v >= 0 ? "+" : ""}${v.toFixed(digits)}%`;
}

export function fmtPp(n: number | null | undefined, digits = 1): string {
  if (n == null) return "—";
  const v = Number(n);
  if (Number.isNaN(v)) return "—";
  return `${v >= 0 ? "+" : ""}${(v * 100).toFixed(digits)}pp`;
}
